import { AnchorButtonAppearance as FluentAnchorButtonAppearance, AnchorButtonShape as FluentAnchorButtonShape, AnchorButtonSize as FluentAnchorButtonSize, AnchorTarget as FluentAnchorTarget } from "@fluentui/web-components";
/** Appearance values for {@link AnchorButton}. */
export const AnchorButtonAppearances = {
    ...FluentAnchorButtonAppearance
};
export const AnchorButtonAppearance = AnchorButtonAppearances;
/** Shape values for {@link AnchorButton}. */
export const AnchorButtonShapes = { ...FluentAnchorButtonShape };
export const AnchorButtonShape = AnchorButtonShapes;
/** Size values for {@link AnchorButton}. */
export const AnchorButtonSizes = { ...FluentAnchorButtonSize };
export const AnchorButtonSize = AnchorButtonSizes;
/** Target values for {@link AnchorButton}. */
export const AnchorTargets = { ...FluentAnchorTarget };
export const AnchorTarget = AnchorTargets;
//# sourceMappingURL=anchor-button.options.js.map